module.exports = __webpack_public_path__ + "img/사진2.15bea0ec.png";